import React, { useRef } from "react";
import emailjs from "emailjs-com";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Img1 from "./img1.png";
import Img3 from "./img3.png";
import Img4 from "./img4.png";
import Img5 from "./img5.png";
import Img6 from "./map.png";
import "./content.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import FloatingLabel from "react-bootstrap/FloatingLabel";
// import HereMap from './HereMap';
// import HereMap from "../../components/map/Heremap";

const Content = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const formData = new FormData(form.current);
 

    emailjs
      .sendForm(
        "service_1e57fca",
        "template_rhkazbs",
        form.current,
        "cigYempoXlk-EHTF3"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <>
      <Navb />
      <div className="content">
        <div className="contentTop">Contact Us</div>
      </div>
      <div className="whatwedo_Box backgroundcontact">
        <div
          className="whatwedo_card"
          style={{
            margin: "3rem 0rem",
            height: "21rem",
            "background-color": "#f2f2f2c2",
          }}
        >
          <img src={Img3} alt="Img3" />
          <div className="whatHeading">Contact Us</div>
          <div
            className="blackP"
            style={{
              "padding-top": "2rem",
              "border-top": "1px solid #F3A32B",
              "text-align": "center",
            }}
          >
            18004194501 <br /> (+91) 5322686501
          </div>
        </div>
        <div
          className="whatwedo_card"
          style={{
            margin: "3rem 0rem",
            height: "21rem",
            "background-color": "#f2f2f2c2",
          }}
        >
          <img src={Img4} alt="Img4" />
          <div className="whatHeading">Email</div>
          <div
            className="blackP"
            style={{
              "padding-top": "2rem",
              "border-top": "1px solid #F3A32B",
              "text-align": "center",
            }}
          >
            info@ecavo.in
          </div>
        </div>
        <div
          className="whatwedo_card"
          style={{
            margin: "3rem 0rem",
            height: "21rem",
            "background-color": "#f2f2f2c2",
          }}
        >
          <img src={Img5} alt="Img5" />
          <div className="whatHeading">Address</div>
          <div
            className="blackP"
            style={{
              "padding-top": "2rem",
              "border-top": "1px solid #F3A32B",
              "text-align": "center",
            }}
          >
            C- 49, Industrial Area, Naini, Prayagraj, Uttar Pradesh, 211009
          </div>
        </div>
      </div>
      <Container>
        <div className="Message">Message Us</div>
        <div className="connectflex">
          <div className="inputs">
            <Form ref={form} onSubmit={sendEmail}>
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    name="name"
                    required
                    placeholder="Name"
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="number"
                    name="phonenumber"
                    required
                    placeholder="Phone Number"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Control
                    type="email"
                    name="email"
                    required
                    placeholder="Email"
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="text"
                    name="subject"
                    required
                    placeholder="Subject"
                  />
                </Col>
              </Row>
              <FloatingLabel controlId="floatingTextarea2" label="Comments">
                <Form.Control
                  type="text"
                  name="comment"
                  required
                  as="textarea"
                  placeholder="Leave a comment here"
                  style={{ height: "100px" }}
                />
              </FloatingLabel>
              <button type="submit" className="sendButton">
                Send
              </button>{" "}
              {/* Use type="submit" to trigger form submission */}
            </Form>
            {/* <button className="sendButton">Send</button> */}
          </div>
        </div>
      </Container>
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1803.0028330392527!2d81.91304694861175!3d25.33759089604527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3985357400000001%3A0x2e3ee0f976a10df1!2sECAVO%20AGRO%20DAILY%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1723029135610!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <Footer />
    </>
  );
};

export default Content;
